import React from 'react';
import { HiOutlineCheckCircle, HiOutlineXCircle } from 'react-icons/hi';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-hot-toast';
import Modal from './Modal';
import { Button } from '../Form';

const SelectedHistorialModal = ({ closeModal, isOpen, historial, onImprimir }) => {
  const [localDatas, setLocalDatas] = React.useState(
    historial.map((item) => ({ ...item, selected: false }))
  );

  const handleSelected = (index) => {
    setLocalDatas((prev) =>
      prev.map((item, i) => (i === index ? { ...item, selected: !item.selected } : item))
    );
  };

  const selectAll = () => {
    const todoSeleccionado = localDatas.every((item) => item.selected);
    setLocalDatas((prev) => prev.map((item) => ({ ...item, selected: !todoSeleccionado })));
  };

  const handleImprimir = () => {
    const seleccionados = localDatas.filter((item) => item.selected);
    if (seleccionados.length === 0) {
      toast.error('Debe seleccionar al menos una cita');
      return;
    }
    confirmAlert({
      customUI: ({ onClose }) => (
        <div className="custom-ui flex flex-col text-center gap-5 border border-gray-400 rounded-lg p-5 bg-white">
          <h1 className="font-bold text-lg">Descargar Historial</h1>
          <p>¿Desea descargar el historial de las citas seleccionadas?</p>
          <div className="flex flex-row gap-5 lg:gap-10">
            <Button label="No" Icon={HiOutlineXCircle} onClick={onClose} />
            <Button
              label="Sí"
              Icon={HiOutlineCheckCircle}
              onClick={() => {
                onClose();
                closeModal();
                onImprimir(seleccionados);
              }}
            />
          </div>
        </div>
      ),
    });
  };

  const todoSeleccionado = localDatas.every((item) => item.selected);

  return (
    <Modal closeModal={closeModal} isOpen={isOpen} title="Seleccionar citas" width="max-w-lg">
      <div className="flex flex-col gap-4">
        {/* Seleccionar todo */}
        <label className="flex items-center gap-2 text-sm text-textGray cursor-pointer select-none border-b border-border pb-2">
          <input
            type="checkbox"
            checked={todoSeleccionado}
            onChange={selectAll}
            className="accent-subMain"
          />
          {todoSeleccionado ? 'Deseleccionar todo' : 'Seleccionar todo'}
        </label>

        {/* Lista de citas */}
        <div className="flex flex-col gap-2 max-h-72 overflow-y-auto pr-1">
          {localDatas.map((cita, idx) => (
            <label
              key={idx}
              className="flex items-center gap-3 cursor-pointer p-2 rounded-lg hover:bg-dry transition-colors"
            >
              <input
                type="checkbox"
                checked={cita.selected}
                onChange={() => handleSelected(idx)}
                className="accent-subMain"
              />
              <div className="flex flex-col">
                <span className="text-sm font-medium text-main">{cita.fecha}</span>
                <span className="text-xs text-textGray">
                  {cita.tipo_evento} — {cita.piezas.length} pieza{cita.piezas.length !== 1 ? 's' : ''}
                </span>
              </div>
            </label>
          ))}
        </div>

        {/* Botones */}
        <div className="flex justify-end gap-2 pt-2 border-t border-border">
          <Button label="Cancelar" onClick={closeModal} />
          <Button label="Descargar" Icon={HiOutlineCheckCircle} onClick={handleImprimir} />
        </div>
      </div>
    </Modal>
  );
};

export default SelectedHistorialModal;
